import { ModuloService } from './../services/modulo.service';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DataService } from './../services/data.service';
import { AppService } from './../services/app.service';
import { Observable } from 'rxjs';
import { ApiService } from '../services/api.service';

@Injectable({
    providedIn: 'root'
  })
export class ModulosResolver implements Resolve<any> {
    
    private title;
    public data = null;

    constructor(
        private DataService:DataService,
        private modulo: ModuloService,
        private app: AppService,
        private api: ApiService
    ){

        this.onData();

    }
    /**
     * 
     * Ouvintes
     * 
     */
    onData(){
              
        this.modulo.getModulosEmitter.subscribe(d =>{
            this.modulo.updateModulosEmitter.emit(this.data);
        });

    }  
    /**
     * 
     * Resolve
     * 
     * @param route 
     * @param state 
     * 
     */
    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
        ):Observable<any>|Promise<any>|any {
           
            let modulos      = this.DataService.getModulos();
            let configuracao = this.DataService.getConfiguracao();
            
            if(this.data == null){
            //if(modulos == null){

                return this.api.modulos().getModulos().subscribe(response =>{
                    
                    let r:any = response;

                    if(r.status == 1){
                     
                        this.data = r.data;
                        this.DataService.setModulos(r.data);
                        this.modulo.updateModulosEmitter.emit(this.data);
                        //this.DataService.setTotalCart(response.totalCart);
                        this.DataService.setConfiguracao(response.configuracao);
                        //this.DataService.setCategoriasMenu(response.categoria_menu);
                        //this.AppService.setMetaDadosInit(response.configuracao);
                        this.app.setStatusServidorEmitter.emit(1);
                    }
                    
                    this.app.emitChangePage.emit(route.params);
                    this.app.toTop(); 

                    return response;
                   
                }, (err) => {
                    this.app.setStatusServidorEmitter.emit(500);
                });

           }else{
               this.data = modulos;
               this.modulo.updateModulosEmitter.emit(this.data);
               //this.AppService.setMetaDadosInit(configuracao);
               //this.AppService.setStatusServidorEmitter.emit(1);
               //this.AppService.emitChangePage.emit(route.params);
               
               return this.data
           }
    }

 }
